export const ADD_MODULE = 'ADD_MODULE';
export const REMOVE_MODULE = 'REMOVE_MODULE';
export const INCREMENT_USERS = 'INCREMENT_USERS';
export const DECREMENT_USERS = 'DECREMENT_USERS';